var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancellationReasons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3495_9374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00781 2.03394C9.65355 0.642655 12.744 0.359967 15.5986 1.24683C17.3116 1.77908 18.8535 2.70894 20.1152 3.93726C20.1704 3.96153 20.2224 3.99556 20.2676 4.04077C20.3128 4.08599 20.3468 4.1379 20.3711 4.19312C21.1022 4.95214 21.7311 5.81492 22.2305 6.7644C23.6218 9.41023 23.9055 12.5005 23.0186 15.3552C22.1315 18.2099 20.1467 20.5956 17.501 21.9871C14.8551 23.3784 11.7639 23.6622 8.90918 22.7751C6.05465 21.888 3.66868 19.9033 2.27734 17.2576C0.885999 14.6117 0.603214 11.5205 1.49023 8.66577C2.37733 5.81119 4.36213 3.42531 7.00781 2.03394ZM5.37695 19.6375C6.4706 20.6238 7.77267 21.3746 9.20605 21.8201C11.8075 22.6284 14.624 22.3701 17.0352 21.1023C17.8172 20.691 18.535 20.1831 19.1768 19.5974L12.2969 12.7175L5.37695 19.6375ZM4.66699 5.08765C3.66076 6.1904 2.89681 7.50975 2.44531 8.96265C1.63699 11.5641 1.89518 14.3806 3.16309 16.7917C3.57428 17.5737 4.08161 18.2917 4.66699 18.9333L11.5898 12.0105L4.66699 5.08765ZM13.0049 12.0105L19.8818 18.8875C20.8678 17.7937 21.6181 16.4915 22.0635 15.0583C22.8717 12.457 22.6135 9.64122 21.3457 7.23022C20.9439 6.4661 20.4505 5.76302 19.8818 5.13257L13.0049 12.0105ZM15.3018 2.2019C12.7004 1.39378 9.88459 1.65187 7.47363 2.91968C6.70993 3.32131 6.00714 3.81439 5.37695 4.38257L12.2979 11.3035L19.1768 4.42358C18.0738 3.4175 16.7546 2.65333 15.3018 2.2019Z",
    fill: "#85909F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3495_9374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancellationReasons);
export default __webpack_public_path__ + "static/media/cancellationReasons.0d9449c5f588cc12a49ec5f61d29b734.svg";
export { ForwardRef as ReactComponent };